import React, { Component } from 'react';
import { TwitterShareButton, VKShareButton, FacebookShareButton, OKShareButton } from 'react-share'
import './social.critical.css'
import {
  FacebookIcon,
  TwitterIcon,
  VKIcon,
  OKIcon
} from 'react-share';
import { sendEvent } from '../../helpers/analytics'

class Social extends Component {
  state = {
    visible: false
  }

  render () {
    let styles = {
      fill: 'transparent'
    };

    const size = 20;
    const { visible } = this.state

    return (
      <div className="share"
           onMouseOver={() => this.setState({visible: true})}
           onMouseOut={() => this.setState({visible: false})}
      >
        <div className="share__icon" style={{display: visible ? 'none' : 'block'}}>
          <img src="/images/share.png" alt="" />
        </div>
        <div className="share__buttons"  style={{opacity: visible ? 1 : 0}}>
          <VKShareButton url={window.location.href}>
            <span onClick={() => sendEvent('main', 'click', 'share vk')}>
              <VKIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </VKShareButton>
          <FacebookShareButton url={window.location.href}>
            <span onClick={() => sendEvent('main', 'click', 'share fb')}>
              <FacebookIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </FacebookShareButton>
          <TwitterShareButton url={window.location.href}>
            <span onClick={() => sendEvent('main', 'click', 'share tw')}>
              <TwitterIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </TwitterShareButton>
          <OKShareButton url={window.location.href}>
            <span onClick={() => sendEvent('main', 'click', 'share ok')}>
              <OKIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </OKShareButton>
        </div>
      </div>
    )
  }
}

export default Social


// WEBPACK FOOTER //
// ./src/components/share/share.js